import React from 'react'

const JavaScript_Essentials_Course_Exam = () => {
  return (
    <div>
      <h1>js Course Exam</h1>
    </div>
  )
}

export default JavaScript_Essentials_Course_Exam
